module.exports = __webpack_public_path__ + "static/media/4.15069c5f.jpg";